import { store } from "@redux"
import { stringify } from "query-string"

import { resolveStorageUrl, toStoragePath } from "utils"
import { farasodStorage } from "./api"

const endpoint = "/image"

export const uploadImage = async (
  data,
  imageCategory,
  onUploadProgress, source = { token: null }
) => {

  const response =
    await farasodStorage.post(
      `${endpoint}?imageCategory=${imageCategory}`,
      data,
      {
        cancelToken: source.token,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress
      }
    )

  return {
    ...response.data,
    storagePath: response.data.url,
    url: response.data.fullUrl || resolveStorageUrl(response.data.url)
  }
}

export const downloadBillImage = async url => {
  const response =
    await farasodStorage.get(
      resolveStorageUrl(url),
      { responseType: "arraybuffer" }
    )

  return response
}

export const getMedia = async (queries) => {
  const contractId =
    store.getState().systemSettings.contractId

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasodStorage.get(`/stats/stats/${contractId}/list?${query}`)

  return response.data.map(image => ({
    ...image,
    url: resolveStorageUrl(image.url)
  }))
}

export const getMediaStats = async () => {
  const contractId =
    store.getState().systemSettings.contractId

  const response = await farasodStorage.get(`/stats/stats/${contractId}`)

  return response.data
}

export const deleteImage = async (url) => {
  const array = String(toStoragePath(url)).split("/")

  const imageName = array.pop()

  const imageDir = array.pop()

  const response = await farasodStorage.delete(`${endpoint}/${imageDir}/${imageName}`)

  return response.data
}
